import {
  movementReferenceLabel,
  movementTypeLabel,
  stockStateLabel,
} from '../../utils/inventoryLabels';
import { formatMovementMoment } from './movementsUtils';

/*
 * The whole kardex of a filter as a sheet, not the page on screen: a month of
 * adjustments is read in Excel, and the person asking for it wants all of it.
 */

/** The server hands at most this many per page. */
export const EXPORT_PAGE_SIZE = 100;

/**
 * The most an export carries. Beyond it the sheet is no longer something
 * somebody reads, and the request would hold the browser for minutes; the
 * notice says to narrow by date.
 */
export const EXPORT_LIMIT = 10000;

/**
 * The rows as a sheet, with the headers a person reads. Numbers go out as
 * numbers so the sheet can add them up.
 *
 * @param {Array<object>} rows - As `inventories/movements/` sent them.
 * @returns {Array<object>}
 */
export const buildMovementsExportRows = (rows) =>
  rows.map((row) => ({
    Fecha: formatMovementMoment(row.occurred_at),
    Cliente: row.company_name || '',
    SKU: row.product_sku,
    Producto: row.product_name,
    Movimiento: movementTypeLabel(row.movement_type),
    Estado: stockStateLabel(row.state),
    Origen: movementReferenceLabel(row),
    Motivo: row.notes || '',
    Bodega: row.warehouse_name,
    Ubicación: row.slot_name || 'Sin ubicar',
    Lote: row.lot || '',
    Cantidad: Number(row.qty_delta),
    Saldo: row.balance_after === null || row.balance_after === undefined ? '' : Number(row.balance_after),
    Unidad: row.base_uom || '',
    Quién: row.actor_email || 'sistema',
  }));

/**
 * @param {object|null} warehouse - The warehouse in use, or `null` for all.
 * @param {{dateFrom?: string, dateTo?: string}} filters
 * @returns {string}
 */
export const movementsExportFileName = (warehouse, filters = {}) => {
  const range = [filters.dateFrom, filters.dateTo].filter(Boolean).join('_a_');
  return `movimientos-${warehouse ? warehouse.name : 'todas'}${range ? `-${range}` : ''}.xlsx`;
};

/**
 * What the page says once the file is written.
 *
 * @param {number} exported - Rows in the sheet.
 * @param {number} total - Rows the filter has.
 */
export const exportDoneNotice = (exported, total) =>
  total > exported
    ? `Se exportaron los ${exported.toLocaleString('es-CL')} movimientos más recientes de ${total.toLocaleString(
        'es-CL'
      )}. Acota por fecha para el resto.`
    : `Se exportaron ${exported.toLocaleString('es-CL')} movimientos.`;
